import { render } from "./InternetSpeed.vue?vue&type=template&id=7decf9f0"
import script from "./InternetSpeed.vue?vue&type=script&lang=js"
export * from "./InternetSpeed.vue?vue&type=script&lang=js"

import "./InternetSpeed.vue?vue&type=style&index=0&id=7decf9f0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__